import React, { useCallback } from 'react';
import { DataGrid, Column, HeaderFilter,
  Paging, SearchPanel, Export,
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid as xlsExportDataGrid } from 'devextreme/excel_exporter';

export default function ESGReportData(props) {

  const onExporting = useCallback((e) => {
    if (e.format === "xlsx") {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');

      xlsExportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AXPC-ESG-Data.xlsx');
        });
      });
    }
  }, []);

  const formatCompanyName = (cellInfo) => {
    if (cellInfo.value) {
      return cellInfo.value;
    }
    return "Hidden Company Name";
  }

  return (
    <div>

      {props.data && <div className={'content-block'}>

        <DataGrid id="dataGrid"
          dataSource={props.data}
          columnHidingEnabled={false}
          cellHintEnabled={true}
          wordWrapEnabled={true}
          onExporting={onExporting}
        >
          <Export enabled={true} formats={['xlsx']} />
          <HeaderFilter visible={true} />
          <SearchPanel visible={true} width="300px"/>
          <Column
            dataField={'year'}
            caption={'Year'}
            defaultSortOrder="desc"
            visibleIndex={1}
            width="110px"
          >
          </Column>
          <Column
            dataField={'company_name'}
            caption={'Company'}
            visibleIndex={2}
            width="120px"
            customizeText={formatCompanyName}
          />
          <Column
            dataField={'Identifier'}
            name="ID"
            allowSorting={true}
            visibleIndex={0}
            dataType="number"
            width="140px"
          >
          </Column>
          <Column
            dataField={'Category'}
            visibleIndex={3}
            width="120px"
          >
          </Column>
          <Column
            dataField={'Boundary'}
            visibleIndex={4}
            width="120px"
          >
          </Column>
          <Column
            dataField={'Metrics'}
            visibleIndex={5}
            width="260px"
          >
          </Column>
          <Column
            dataField={'Units'}
            visibleIndex={7}
            width="260px"
          >
          </Column>
          <Column
            dataField={'value'}
            caption={'Value'}
            visibleIndex={6}
            width="140px"
          >
          </Column>
          <Column
            dataField={'Additional Notes'}
            caption={'Additional Notes'}
            visibleIndex={7}
            width="140px"
          >
          </Column>

          <Paging defaultPageSize={100} />
        </DataGrid>
      </div>}

    </div>
  );
}
